import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

function DashboardLayout() {
  const location = useLocation();

  const isActive = (path: string): boolean => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar Navigation */}
      <nav className="w-[250px] bg-dark fixed h-screen overflow-y-auto shadow-lg">
        {/* Header */}
        <div className="px-5 py-[28px] border-b border-white/10 bg-dark-lighter">
          <h1 className="m-0 mb-1 text-2xl font-semibold text-white">
            HR Dashboard
          </h1>
          <p className="m-0 text-[13px] text-sidebar-subtitle">
            Interview Management System
          </p>
        </div>

        {/* Navigation Menu */}
        <ul className="py-5 m-0 list-none">
          <li className={`m-0 ${isActive('/dashboard/jobs') ? 'bg-sidebar-active border-l-[3px] border-sidebar-border' : ''}`}>
            <Link
              to="/dashboard/jobs"
              className={`flex items-center px-[20px] py-[15px] text-[15px] transition-all duration-200 no-underline ${
                isActive('/dashboard/jobs')
                  ? 'text-white font-medium'
                  : 'text-sidebar-text hover:bg-sidebar-hover hover:text-white'
              }`}
            >
              <span className="text-xl mr-3 min-w-[24px]">💼</span>
              <span>Jobs</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* Main Content */}
      <main className="flex-1 ml-[250px] p-8 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}

export default DashboardLayout;
